/**
 * ユーザ
 */
import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    DialogTitle,
    Grid
} from '@material-ui/core'
import {
    getUser,
    userDelete,
    putReset,
} from 'mdoc/admin/axios/user'
import { dictionary, getPermissions } from 'mdoc/admin/axios'
import CustomizedTable from 'mdoc/utils/table'
import { Link } from 'react-router-dom'
import Dialog from 'mdoc/utils/myDialog'
import Toast from 'mdoc/utils/toast';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    title: {
        marginLeft: '-20px'
    },
    titleDialog: {
        marginLeft: '-20px',
        fontWeight:'bold'
    }
});

class User extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        permissions: [],
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            page: 1,
            count: 0,
            sidx: '',
            sord: ''
        },
        open: false,
        dictWord: {
            'user_registration': '',
            'user_id': '',
            'contact_person_name': '',
            'email': '',
            'owner_department': '',
            'department_seach': '',
            'tel_no': '',
            'department_name': '',
            'final_access_date': '',
            'login_date': '',
            'certification_reset': '',
            'reset': '',
            'management': '',
            'user_multiple_registration': '',
            'user_log': '',
            'modify_record': '',
            'delete_record': '',
            'msg_confirm_really_delete': '',
            'yes': '',
            'cancel': '',
            'confirmation': '',
            'msg_confirm_really_reset': '',
            'registration_date': '',
        },
        dialogOpen: false,
        userCode: '',
        disabled: false,
        dialogOpen2: false,
        id: ''
    }
    componentWillMount() {
        this.start(this.state);
    }
    componentDidMount() {
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        this.setState({
            permissions: permissions
        });
    }
    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }

    fetch = (params = {}) => {
        this.setState({ loading: true })
        getUser({
            ...params
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }


    handleTableChange = (event, pagination) => {
        this.fetch({
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })


    };
    handleSubmit = (id) => event => {
        this.setState({
            id: id,
            dialogOpen: true
        });
    }
    dialogHandleOK = (event) => {
        userDelete({
            'id': this.state.id,
        }).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }

    handleSubmitReset = (userCode) => event => {
        this.setState({
            userCode: userCode,
            dialogOpen2: true
        });
    }
    dialogHandleYES = (event) => {
        putReset({
            'userCode': this.state.userCode,
        }).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    dialogHandleOff = () => {
        this.setState({
            dialogOpen2: false
        });
    }
    render() {
        const { classes } = this.props;
        const { permissions } = this.state;
        const columns = [
            {
                title: this.state.dictWord.user_id,
                dataIndex: 'userCode',
                sorter: true,
                render: (text, record) => <Link to={{ pathname: '/admin/management/user_edit/' + record.id }} className={classes.link}>{text}</Link>,
            }, {
                title: this.state.dictWord.contact_person_name,
                dataIndex: 'name',
            }, {
                title: this.state.dictWord.department_name,
                dataIndex: 'displayCreateDate',
                sortIndex: 'createDate',
                render: (text, record) => {
                    let department = [];
                    if (record.docMstDepartmentList !== undefined) {
                        for (let key in record.docMstDepartmentList) {
                            let column = record.docMstDepartmentList[key];
                            department.push(column.departmentName);
                        }
                    }
                    return department.join('/')
                }
            }
            , {
                title: this.state.dictWord.final_access_date,
                dataIndex: 'displaylastLoginTime',
                sortIndex: 'lastLoginTime',
                sorter: true,
                width: '152px',

            }, {
                title: this.state.dictWord.registration_date,
                dataIndex: 'displayCreateDate',
                sortIndex: 'createDate',
                sorter: true,
                width: '100px',
            }, {
                title: this.state.dictWord.certification_reset,
                key: 'action',
                toolTipDisabled: true,
                width: '120px',
                render: (text, record) => {
                    return <span>
                        <Button variant="contained" color="primary" disabled={parseInt(record.deviceControl) === 1 ? false : true} onClick={this.handleSubmitReset(record.userCode)}>{this.state.dictWord.reset}</Button>
                    </span>
                }
            },
        ]
        if (permissions.includes(3)) {
            columns.push({
                title: this.state.dictWord.management,
                key: 'action',
                toolTipDisabled: true,
                width: '188px',
                style: {
                    overflow: 'none',
                },
                render: (text, record) => (
                    <span>
                        <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/management/user_edit/' + record.id}>{this.state.dictWord.modify_record}</Button>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit(record.id)} className={classes.margin} disabled={parseInt(record.serverId) === 0 ? false : true}>
                            {this.state.dictWord.delete_record}
                        </Button>
                    </span>
                )
            });
        }
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={12}>
                        {permissions.includes(3) ? <Button variant="contained" color="primary" href={'/admin.html#/admin/management/user_edit'} className={classes.margin}>
                            {this.state.dictWord.user_registration}
                        </Button> : null}
                        {permissions.includes(3) ? <Button variant="contained" color="primary" href={'/admin.html#/admin/management/user_allEdit'} className={classes.margin}>
                            {this.state.dictWord.user_multiple_registration}
                        </Button> : null}
                        {permissions.includes(11) ? <Button variant="contained" color="primary" href={'/admin.html#/admin/management/user_log'} className={classes.margin}>
                            {this.state.dictWord.user_log}
                        </Button> : null}
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_confirm_really_delete']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
                <Dialog
                    open={this.state.dialogOpen2}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.titleDialog}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_confirm_really_reset']}</p>
                    }
                    handleOk={this.dialogHandleYES}
                    handleClose={this.dialogHandleOff}
                />
            </div>
        )
    }
}

User.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(User);